export default "__VITE_ASSET__CUb1OaUk__";